<template>
	<div class="news-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home"><i class="n el-icon-s-home"></i>首页</el-breadcrumb-item>
			<el-breadcrumb-item class="path-news">行业动态</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading">
			<div class="content">
				<div class="left-column">
					
					<div class="tab-list">
						<el-tabs >
						  <el-tab-pane v-for="(tab,i) in tabs" :key="tab.id">
							  <!-- <i class="el-icon-date"></i> -->
						    <span slot="label">{{tab.name}}</span>
						    <div class="list" >
								<div class="item" v-for="(item,i) in list" :key="i">
									<router-link :to="`/news-detail-${item.id}`" target="_blank">
										<h2>{{item.title}}</h2>
										<el-image fit="cover" class="image" :src="$img(item.image)" @error="item.image = defaultGoodsImage" />
										<div class="con">
											<desc-text class="text" :text="item.content" :textStyle="{WebkitLineClamp:4}"></desc-text>
											<!-- <div class="desc">{{item.datetime.date}}</div> -->
											<div class="tags">
												<span>{{item.datetime.date}}</span>
											</div>
										</div>
									</router-link>
								</div>
							</div>
						  </el-tab-pane>
						</el-tabs>
						<el-pagination
						  background
						  layout="prev, pager, next"
						  :total="total"
						  :page-size="pageSize"
						  :current-page="currentPage"
						  @current-change="getList"
						  >
						</el-pagination>
					</div>
				</div>
				<div class="right-column">
					<sidebar></sidebar>
				</div>
			</div>
			<div class="ad-1"  v-if="ad1">
				<el-image :src="$img(ad1.adv_image)" fit="cover" @click="$router.pushToTab(ad1.adv_url.url)" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import { adList } from "@/api/website"
	import { mapGetters } from "vuex"
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	import sidebar from "./components/sidebar"
	
	export default {
		name: "news_list",
		components: {
			SubTitle,
			DescText,
			sidebar
		},
		data: () => {
			return {
				// classList:[],
				list: [],
				loading: true,
				tabs:[],
				ad1:null,
				cat_id:null,
				total:0,
				cat:null,
				pageSize:10,
				currentPage:1
			};
		},
		created() {
			this.cat_id = this.$route.path.replace('/news-list-', '');
			this.getInfo();
		},
		computed: {
		    ...mapGetters(["defaultGoodsImage"])
		},
		methods: {
			getInfo() {
				// this.loading = false;
				this.getList()
				// this.getFlagList()
				this.getCat()
				this.getAd1();
				// newsList({
				// 		app_module: "admin"
				// 	})
				// 	.then(res => {
				// 		if (res.code == 0 && res.data) {
				// 			this.$router.push({
				// 				path: "/cms/news/listother-" + res.data[0].class_id
				// 			});
				// 			this.currentId = res.data[0].class_id;
				// 			this.newsList = res.data;
				// 		}
				// 		this.loading = false;
				// 	})
				// 	.catch(err => {
				// 		this.loading = false;
				// 		this.$message.error(err.message);
				// 	});
			},
			getCat(){
				newsCat({
					list:true,
					// exclude:15,
					ids:[
						this.cat_id
					]
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.tabs = res.data;
						this.cat = res.data[0];
						this.$util.seo({
							title:`${this.cat.name}混凝土机械新闻网，混凝土机械行业新闻，混凝土机械租赁专题，混凝土机械施工设备招标信息-中械云配新闻资讯-中械云配`,
							keywords:`${this.cat.name},混凝土机械${this.cat.name}新闻网，混凝土机械行业新闻，混凝土机械租赁专题，混凝土机械施工设备招标信息,${this.cat.name}中械云配`,
							description:`中械云配提供混凝土机械行业资讯，混凝土机械租赁专题，公路工程、施工设备招标信息，拟在建项目信息等，是混凝土机械行业从业者看工程机械新闻的网站`,
						})
					}
				})
			},
			getList(val){
				// console.log(333)
				this.currentPage  = val || this.currentPage
				newsList({
					cat_id:this.cat_id,
					page_size:this.pageSize,
					page:this.currentPage,
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.list = res.data.list;
						this.total = res.data.total
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
			},
			getAd1(){
				adList({ keyword: "PC_NEWS_INDEX" })
				    .then(res => {
				        this.ad1 = res.data.adv_list[0]
				    })
				    .catch(err => {
				    })
			}
		}
	};
</script>
<style lang="scss" scoped>
.news-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}

.news {
	// display: flex;
	padding-bottom: 20px;
}
	
.news .content{
	display: flex;
	flex-flow: wrap;
	width: 1210px;
	margin-bottom: 20px;
	.left-column{
		width: 900px;
		// flex: 1;
		display: block;
		.sub-list{
			.list{
				display: flex;
				.item:first-child{
					margin-left: 0;
				}
				.item{
					width: 33.333%;
					margin-left: 30px;
					// padding-bottom: 10px;
					border: 1px solid #efefef;
					margin-bottom: 20px;
					overflow:hidden;
					.image{
						width: 100%;
						height: 200px;
					}
					p{
						padding: 5px 10px;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					// padding: 15px;
				}
			}
		}
		.tab-list{
			.list{
				.item{
					display: block;
					h2{
						padding: 5px;
						width: 100%;
						display: block;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
						line-height: 60px;
					}
					.image{
						width: 22%;
						float: left;
						height: 140px;
					}
					.con{
						width: 78%;
						float: left;
						padding: 0  0 0 15px;
						overflow: hidden;
						box-sizing: border-box;
						.text{
							height: 115px;
						}
						.tags{
							span{
								float: right;
							}
						}
					}
				}
			}
		}
	}
	.right-column{
		// width: 260px;
		flex: 1;
		padding-left: 20px;
		overflow: hidden;
	}
}
.news .ad{
	display: block;
}
</style>
